import React, { useState } from "react";
import { Select } from "antd";
import { Button } from "../../components";
import { Typography } from "antd";
import Slider from "react-slick";
import PSG from "../../assets/psg.png";
import Ajax from "../../assets/teams/ajax.png";
import Chelsea from "../../assets/teams/chelsea.png";
import City from "../../assets/teams/city.png";
import Everton from "../../assets/teams/everton.png";
import Man from "../../assets/teams/man.png";
import Tot from "../../assets/teams/tot.png";
import WestHam from "../../assets/teams/westham.png";
import Villa from "../../assets/teams/villa.png";
import Watford from "../../assets/teams/wat.png";

import { sliderSettings } from "./sliderSettings";

import "./style.css";

const { Title } = Typography;
const { Option } = Select;

const teams = [
  {
    img: PSG,
    title: "PSG",
  },
  {
    img: Ajax,
    title: "Ajax",
  },
  {
    img: Chelsea,
    title: "Chelsea",
  },
  {
    img: City,
    title: "Man city",
  },
  {
    img: Everton,
    title: "Everton",
  },
  {
    img: Man,
    title: "Man united",
  },
  {
    img: Tot,
    title: "Tottenham",
  },
  {
    img: WestHam,
    title: "West Ham",
  },
  {
    img: Villa,
    title: "Villa",
  },
  {
    img: Watford,
    title: "Watford",
  },
];

const FavouriteTeams = () => {
  const [tags, setTags] = useState([]);

  const onChangeTags = (tag) => {
    if (tags.indexOf(tag) > -1) {
      setTags(tags.filter((item) => item !== tag));
    } else {
      setTags((arr) => [...arr, tag]);
    }
  };

  return (
    <>
      <Title level={3}> Favourite Teams </Title>
      <Title level={5}>
        {" "}
        Which team would you like us to send you notifications updates?{" "}
      </Title>
      <Title level={5}>
        {" "}
        Set your fixtures reminder by selecting your favorite team in all sports
        and league{" "}
      </Title>
      <Slider {...sliderSettings}>
        <div>
          <Button
            type="primary"
            className="mt-10 primary-color button-tetiary"
            title="Soccer"
            style={{
              height: "50px",
              borderRadius: "30px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
        <div>
          <Button
            type="primary"
            className="mt-10 primary-color button-transparent-tetiary"
            title="Basketball"
            style={{
              borderRadius: "30px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
        <div>
          <Button
            type="primary"
            className="mt-10 primary-color button-transparent-tetiary"
            title="Tennis"
            style={{
              borderRadius: "30px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
        <div>
          <Button
            type="primary"
            className="mt-10 primary-color button-transparent-tetiary"
            title="Cricket"
            style={{
              borderRadius: "30px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
        <div>
          <Button
            type="primary"
            className="mt-10 primary-color button-transparent-tetiary"
            title="Cricket"
            style={{
              borderRadius: "30px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
      </Slider>
      <div className="mt-12">
        <Select defaultValue="Select League" style={{ width: 200 }} className="fav-teams">
          <Option value="jack">England</Option>
          <Option value="lucy">France</Option>
          <Option value="Yiminghe">Spain</Option>
        </Select>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 grid-rows-1 mt-10 mb-5">
        {teams.map((item, index) => {
          return (
            <div key={index} className={"flex flex-col items-center"}>
              <div
                className={`${
                  tags.indexOf(item.title) > -1 ? "item-active" : "no-border"
                } w-28 h-28 rounded-full flex items-center justify-center`}
                style={{ background: "#EFEFEF" }}
                onClick={() => onChangeTags(item.title)}
              >
                <img src={item.img} />
              </div>
              <div className="mt-5">
                <Title level={5}>{item.title}</Title>
              </div>
            </div>
          );
        })}
      </div>
      <div className="text-center mt-10">
        <p>Load More</p>
      </div>
    </>
  );
};

export default FavouriteTeams;
